"use client";

import React from "react";
import type { SidebarNavDropdownItem, SidebarNavItem, SidebarNavSubItem } from "./SidebarNav.types";
import { SidebarMenuSubButton, SidebarMenuSubItem } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";

type Props = {
  item: SidebarNavSubItem;
  collapsed: boolean;
  pathname: string;
  onNavigate: (item: SidebarNavItem | SidebarNavDropdownItem) => void;
};

export const SidebarSubNavItem: React.FC<Props> = ({ item, collapsed, pathname, onNavigate }) => {
  const active = pathname === item.href;
  const Icon = item.icon;

  return (
    <SidebarMenuSubItem>
      <SidebarMenuSubButton asChild isActive={active} className={cn(item.hoverClassName, item.activeClassName)}>
        <a
          href={item.href}
          onClick={(e) => {
            e.preventDefault();
            onNavigate(item as unknown as SidebarNavItem);
          }}
        >
          {item.iconRender ? item.iconRender({ active, collapsed }) : Icon ? <Icon className="h-4 w-4" /> : null}
          <span>{item.label}</span>
        </a>
      </SidebarMenuSubButton>
    </SidebarMenuSubItem>
  );
};
